/** Apply OCR confirm/reject to the wagon list. Reject leaves wagons unchanged. */
export function applyOcrResolution(wagons, item, number, action, actorKey, nowIso = () => new Date().toISOString()) {
  if (action !== "confirm" || !item?.wagon_id) return wagons;
  return wagons.map((w) => {
    if (w.id !== item.wagon_id) return w;
    return {
      ...w,
      number,
      ocr_confidence: 1,
      updated_at: nowIso(),
      updated_by: actorKey,
    };
  });
}
